import { ShapeItemType } from "@mapmycustomers/shared/types/map/PinLegend";

const isDefaultShapeOption = (shape: ShapeItemType) =>
  "fieldValue" in shape && shape.fieldValue == null;

export default isDefaultShapeOption;
